<div fxLayout="column">
    <div style="font-size: x-large; font-weight: 400;" class="my-2">{{"active_quotation"|translate}}</div>
    <div style="font-size: large; color: rgb(109, 102, 102);" class="mb-3">{{"confirm_quotation_details"|translate}}</div>

    <mat-form-field class="my-2" appearance="outline">
        <mat-label class="me-1">{{"search"|translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Quotation ID" #input>
    </mat-form-field>
    <div *ngIf="dataSource" class="card-table overflow-auto">
        <table class="mat-elevation-z0 w-full" mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"id"|translate}} </th>
                <td mat-cell  *matCellDef="let row"> {{row.invoiceReference}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header> {{"status"|translate}} </th>
                <td mat-cell  *matCellDef="let row"  class="text-center w-10" [style.color]="status[row.status]?.color"> {{status[row.status]?.text }} </td>
              </ng-container>

              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"company"|translate}} </th>
                <td mat-cell *matCellDef="let row"> {{translateHelper.localize(row.companyData?.name)}} </td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"date_created"|translate}} </th>
                <td mat-cell *matCellDef="let row" > {{row.quoteDate|date}} </td>
              </ng-container>

              <ng-container matColumnDef="lastUpdatedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"last_update_date"|translate}} </th>
                <td mat-cell *matCellDef="let row" > {{row.lastUpdated|date}} </td>
              </ng-container>

              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"total"|translate}} </th>
                <td mat-cell *matCellDef="let row" >
                 <span *ngIf="row.status !== 'new'">{{row.total}}BHD</span>
                 <span *ngIf="row.status === 'new'"> - </span></td>
              </ng-container>

              <tr  mat-header-row  *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row;  columns: displayedColumns;"[routerLink]="['/account/quotations',row._id]" class="cursor-pointer"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>

<!-- <div *ngIf="userDetails" class="dashboard">
    <div class="dashboard__profile card profile-card">
        <div class="card-body profile-card__body">
           <div class="profile-card__avatar">
                <img src="./assets/images/avatars/avatar-3.jpg" alt="">
            </div>
            <div class="profile-card__name">{{userDetails.name}}</div>
            <div class="profile-card__email">{{userDetails.email}}</div>
            <div class="profile-card__edit">
                <a routerLink="../profile" class="btn btn-secondary btn-sm">Edit Profile</a>
            </div>
        </div>
    </div>
    <div class="dashboard__address card address-card address-card--featured">
        <div class="address-card__badge" *ngIf="address.default">Default Address</div>
        <div class="address-card__body">
            <div class="address-card__name">{{userDetails.name}}</div>
            <div class="address-card__row">
                {{ address.country }}<br>
                {{ address.postcode }}, {{ address.city }}<br>
                {{ address.address }}
            </div>
            <div class="address-card__row">
                <div class="address-card__row-title">Phone Number</div>
                <div class="address-card__row-content">{{ userDetails.addresses[0]?.phone }}</div>
            </div>
            <div class="address-card__row">
                <div class="address-card__row-title">Email Address</div>
                <div class="address-card__row-content">{{ userDetails.email }}</div>
            </div>
             <div class="address-card__footer">
                <a routerLink="/account/addresses/5">Edit Address</a>
            </div>
        </div>
    </div>
    <div class="dashboard__orders card">
        <div class="card-header">
            <h5>Recent Orders</h5>
        </div>
        <div class="card-divider"></div>
        <div class="card-table">
            <div class="table-responsive-sm">
                <table>
                    <thead>
                    <tr>
                        <th>Order</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let order of orders">
                        <td><a href="">#{{ order.id }}</a></td>
                        <td>{{ order.date }}</td>
                        <td>{{ order.status }}</td>
                        <td>{{ order.total|currencyFormat }} for {{ order.quantity }} item(s)</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
 -->
